<template>
  <div class="layout-footer mx-4 my-4 text-center">
    <p>Powered by Ask.Bet</p>
    <p>&copy; 2026 Voxbet. All rights reserved.</p>
    <a href="mailto:info@voxbet.com">info@voxbet.com</a>
  </div>
</template>
<script setup lang="ts"></script>
